<template>
  <div class="form-section">
    <!-- 外部传入的标题 -->
    <h2 class="curr-step-title" v-if="options && options.title">{{ $t(options.title) }}</h2>
    <!-- 默认标题 -->
    <h2 class="curr-step-title" v-else>{{ $t('signup-visa-card-details') }}</h2>
    <!-- 外部传入的描述 -->
    <div v-if="options && options.warring" class="curr-step-update-card">
      <h3 class="update-title">{{ $t(options.subtitle) }}</h3>
      <p class="update-desc">{{ $t(options.desc) }}</p>
      <p class="update-warring">{{ $t(options.warring) }}</p>
    </div>
    <!-- 默认描述 -->
    <div v-else class="curr-step-desc">
      <span class="step-desc">{{ $t('signup-step-1-desc') }}</span>
      <div class="quession-group">
        <img src="~img/icon-question.png" alt="question icon" class="icon-question" />
        <div class="quession">
          <p class="quession-title">{{ $t('details') }}</p>
          <p class="quession-ctn">{{ $t('whyVc') }}</p>
        </div>
      </div>
    </div>

    <!-- 表单组件部分 -->
    <!-- <keep-alive>
      <restpwd-form v-bind="step1Config" :errMessage="errMessage" ref="restpwdForm"></restpwd-form>
    </keep-alive> -->
    <MembershipForm ref="restpwdForm" />

    <div class="term-desc">
      <div class="check-box" @click="toggleCheck">
        <img src="~img/icon-check.png" alt="checked icon" v-if="checked" />
      </div>
      <div class="desc">
        <p>
          {{ $t('signup-checkbox-desc') }}
        </p>
        <ol class="olList">
          <li>{{ $t('signup-terms-desc-1') }}</li>
          <li>{{ $t('signup-terms-desc-2') }}</li>
        </ol>
        <i18n-t keypath="signup-see-tnc" tag="p">
          <router-link to="/terms" target="_blank" class="tc-link"
            >{{ $t('signup-tnc') }}
          </router-link>
        </i18n-t>
      </div>
    </div>
    <p v-if="showCheckedErr && !checked" class="show-errors">{{ $t('errMsg1') }}</p>
    <div class="btn-wrapper">
      <button class="dpi-button" @click="back">{{ $t('cancel') }}</button>
      <button class="dpi-button dpi-button-primary" @click="vcesVerify">
        {{ $t('continue') }}
      </button>
    </div>
  </div>
</template>

<script>
  import { step1Config } from './step1.config';
  import restpwdForm from '@/components/BaseUi/Form/src/index.vue';
  import verity from '@/utils/verify';
  import { getQueryString, getDeviceId } from '@/utils';
  import { handleCreateSession } from '@/utils/createSession';
  import { mapState } from 'vuex';
  import MembershipForm from '@/components/MembershipForm/index.vue';
  import request from '@/utils/request';

  export default {
    name: 'step1',
    components: {
      restpwdForm,
      MembershipForm,
    },

    props: {
      options: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        step1Config,
        checked: false,
        cardHolderName: '',
        formData: {},
        errMessage: [],
        showCheckedErr: '',
        projectId: '',
        visaToken: '',
        encryptCustomerInput: '',
        cardInfoToken: '',
        dpSessionId: '',
        pciPaymentToken: '',
      };
    },

    computed: {
      ...mapState(['userInfo']),
    },

    mounted() {
      const payOrderNo = getQueryString('payOrderNo');
      const dpSessionId = localStorage.getItem('dpSessionId');
      if (payOrderNo) {
        this.$loading.show();
        this.ingenico3DSNotify(payOrderNo, dpSessionId);
      }
    },

    methods: {
      toggleCheck() {
        this.checked = !this.checked;
      },

      back() {
        this.$router.go(-1);
      },

      vcesVerify() {
        verity(this.$refs.restpwdForm.modalValue).then(errMsg => {
          if (errMsg.pass && this.checked) {
            this.checkVcesVerify(this.$refs.restpwdForm.modalValue);
            this.errMessage = [];
          } else {
            if (!errMsg.pass) {
              // this.errMessage = errMsg;
              // 没过调用子组件自己的检验方法渲染错误信息
              this.$refs.restpwdForm.checkCard();
            }
            if (!this.checked) {
              this.showCheckedErr = true;
            } else {
              this.showCheckedErr = false;
            }
          }
        });
      },

      // 获取可用区域
      getAvailable(data) {
        this.$loading.show();
        return this.$http.login.getAvailable({ lang: data }).then(
          res => {
            if (res.state === '11') {
              res.payload.forEach(item => {
                if (item.regionCode === 'canada') {
                  this.projectId = item.projectId;
                }
                this.$loading.hide();
              });
            } else {
              console.error(res.note);
              this.$loading.hide();
            }
          },
          err => {
            console.error(err);
            this.$loading.hide();
          },
        );
      },

      async checkVcesVerify(formValue) {
        const { cdeDate, visaCardNum } = formValue;

        await this.getAvailable(this.$i18n.locale);

        this.$loading.show();

        try {
          const res = await this.$http.login.vcesVerify({
            channel: this.projectId,
            tokenCode: visaCardNum,
            expiryMonth: cdeDate.expiryMonth,
            expiryYear: cdeDate.expiryYear,
            lang: localStorage.getItem('lang'),
          });

          if (res?.state === '1') {
            this.$nextTick(async () => {
              this.visaToken = res.result.id;
              this.$emit('token', this.visaToken);
              // 获取支付渠道后判断走 checkout 或者 ingenico
              this.getPaymentChannel();
            });
          } else if (res?.state === '00') {
            this.$loading.hide();
            res?.note &&
              this.$messageModal.show({
                image: false,
                desc: res.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
              });
          }
        } catch (err) {
          console.error(err);
          this.$loading.hide();
        }
      },
      // 获取支付渠道
      getPaymentChannel() {
        const params = {
          visaToken: this.visaToken,
          source: this.options.source,
          lang: this.$i18n.locale,
          deviceId: getDeviceId(),
        };
        this.$http.login.getPaymentChannel(params).then(res => {
          if (res.state === '11') {
            const { paymentChannel, pciCacheCardInfoUrl, caller, dpSessionId } = res.data;
            this.dpSessionId = dpSessionId;
            if (paymentChannel === 106) {
              // ingenico
              this.ingenicoVerify();
            } else if (paymentChannel === 167) {
              // checkout
              this.checkoutVerify(pciCacheCardInfoUrl, caller);
            }
          } else {
            console.error(res.note);
          }
        });
      },
      ingenicoVerify() {
        const formValue = this.$refs.restpwdForm.modalValue;
        const { projectId } = this;
        handleCreateSession({ ...formValue, projectId }, this.checkCardInfo);
      },
      checkoutVerify(pciCacheCardInfoUrl, caller) {
        this.$loading.show();
        const { cdeDate, visaCardName, visaCardNum, cardNum } = this.$refs.restpwdForm.modalValue;
        // 调用 pciCacheCardInfoUrl, 获取 paymentToken
        request({
          url: pciCacheCardInfoUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            caller,
          },
          data: {
            cardNumber: visaCardNum,
            cardHolderName: visaCardName,
            expireTime: cdeDate.expiryMonth + cdeDate.expiryYear,
            cvv: cardNum,
          },
        })
          .then(res => {
            if (res.state === '1') {
              this.pciPaymentToken = res.result?.token || '';
              this.checkCardInfo();
            } else {
              this.cardInfoErr = true;
              this.cardErrMsg = res.note;
              this.$loading.hide();
            }
          })
          .catch(err => {
            console.log('checkout err', err);
            this.$loading.hide();
          });
      },
      checkCardInfo(paymentHash) {
        this.encryptCustomerInput = paymentHash;
        const params = {
          visaToken: this.visaToken,
          encryptCustomerInput: paymentHash,
          returnUrl: window.location.href,
          source: this.options.source,
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId || null,
          pciPaymentToken: this.pciPaymentToken,
          deviceUserAgent: navigator.userAgent,
          deviceLocale: this.$i18n.locale,
        };
        return this.$http.login
          .checkCardInfo(params)
          .then(res => {
            if (res.state === '11') {
              if (res.data.needThreeDS) {
                // 跳转链接,跳转之前保存表单数据,用于回填
                localStorage.setItem('visaToken', this.visaToken);
                localStorage.setItem('encryptCustomerInput', this.encryptCustomerInput);
                localStorage.setItem('dpSessionId', this.dpSessionId);
                window.location.href = res.data.threeDSUrl;
              } else {
                this.cardInfoToken = res.data.cardInfoToken;
                // 信用卡是否被注册
                this.checkCardNoStatus();
              }
            } else {
              this.$loading.hide();
              res?.note &&
                this.$messageModal.show({
                  image: false,
                  desc: res.note,
                  i18nNeed: false,
                  closeIcon: true,
                  confirmBtn: 'ok',
                  justHide: true,
                });
            }
          })
          .catch(err => {
            this.$loading.hide();
            console.log(err, 'checkCardInfo');
          });
      },
      ingenico3DSNotify(payOrderNo, dpSessionId) {
        const params = {
          payOrderNo,
          dpSessionId,
          deviceUserAgent: navigator.userAgent,
          deviceLocale: this.$i18n.locale,
          source: this.options.source,
        };
        return this.$http.login
          .ingenico3DSNotify(params)
          .then(res => {
            if (res.state === '11') {
              this.cardInfoToken = res.data.cardInfoToken;
              this.checkCardNoStatus();
            } else {
              this.$loading.hide();
              res?.note &&
                this.$messageModal.show({
                  image: false,
                  desc: res.note,
                  i18nNeed: false,
                  closeIcon: true,
                  confirmBtn: 'ok',
                  justHide: true,
                });
            }
          })
          .catch(err => {
            this.$loading.hide();
            console.log(err, 'ingenico3DSNotify');
          });
      },
      async checkCardNoStatus() {
        // 判断是否需要执行checkCardNoStatus用于membership的updateVisaCard功能
        if (this?.options?.noPerform) {
          const formValue = this.$refs.restpwdForm.modalValue;
          const { projectId, cardInfoToken } = this;
          this.$emit('ingenicoCheck', { ...formValue, projectId, cardInfoToken });
          return;
        }

        // this.$loading.show();
        const paymentHash =
          this.encryptCustomerInput || localStorage.getItem('encryptCustomerInput');
        const res = await this.$http.login.checkCardNoStatus({
          token: this.visaToken || localStorage.getItem('visaToken'),
          lang: localStorage.getItem('lang'),
        });
        if (res.state === '11') {
          this.$nextTick(() => {
            const formValue = this.$refs.restpwdForm.modalValue;
            const { projectId, cardInfoToken } = this;
            this.$emit('ingenicoCheck', { ...formValue, projectId, paymentHash, cardInfoToken });
          });
        } else if (res.state === '00') {
          res?.note &&
            this.$messageModal.show({
              i18nNeed: true,
              image: false,
              desc: res.note,
              closeIcon: true,
              confirmBtn: 'ok',
              justHide: true,
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile.scss';
</style>
